import React from "react"
import {connect} from "react-redux";
import createReactClass from 'create-react-class';
import {Grid, Row, Col, Modal, DropdownButton, MenuItem, Button, Tabs, Tab} from "react-bootstrap";
import {initServerStaticData} from "../../actions/common/staticDataActions";
import {getAccountData, changeSeason, unsubscribeFlag} from "../../actions/account/accountActions";
import AccountSummary from "../account/AccountSummary";
import SelectionTabs from "../../components/common/SelectionTabs";
import SelectionPane from "../../components/common/SelectionPane";
import AccountOverviewPane from "../../components/account/AccountOverviewPane";
import {AccountPickupDirectionsPane} from "../../components/account/AccountPickupDirectionsPane";
import AccountSummaryManagePayments from "./AccountSummaryManagePayments";
import {initMemberData, setMemberKey, setShowPassword} from "../../actions/login/memberDetailsActions";
import LogInScreen from "../login/LogInScreen";
import ContactDetailsForm from "../../components/common/ContactDetailsForm";
import AccountChangePickupSite from "./AccountChangePickupSite";
import AccountChangeSubscription from "./AccountChangeSubscription";
import AccountDeliveryHoldPane from "../../components/account/AccountDeliveryHoldPane";
import {AccountReportsPane} from "../../components/account/AccountReportsPane";
import UserMenu from "../common/UserMenu";
import {setDirty, checkIsDirty, setAndRemoveUrlParams} from '../../actions/common/commonActions';
import {AccountModes, PickupSiteTypes, URLs, SubscriptionHoldReason, SubscriptionStatuses, FetchingTypes} from "../../common/constants";
import LoadingAnimation from "../../components/common/LoadingAnimation";
import {isFetching, errorFetching} from "../../actions/common/fetchingActions";
import ThankYouPage from "../../components/common/ThankYouPage";
import {isEmptyObj, getUrlParams, redirectPage} from "../../common/utils";
import {translate} from '../../i18n/translate.js';
import styles from "../../css/account/accountHomeScreen.less";

const AccountHomeScreen = createReactClass({
    getInitialState(){
        return {showSummary: true, initialView: true};
    },
    componentWillMount() {
        this.props.initServerStaticData();
        if (getUrlParams().mode === 'preview')
            this.props.setMemberKey(getUrlParams().m);
        else
            this.props.initMemberData();
        this.props.setAndRemoveUrlParams(true);
    },
    componentWillReceiveProps(nextProps) {
        if(nextProps.memberDetails.key && !this.props.memberDetails.key) {
            this.props.getAccountData();
            if (getUrlParams().unsubscribe) {
                this.props.unsubscribeFlag(parseInt(getUrlParams().unsubscribe));
            }
        }
        if (!this.state.initialView && nextProps.mode !== AccountModes.VIEW)
            this.closeSummaryModal();
        if(this.props.clientViewPort.isXs && isEmptyObj(this.props.messageData) && !isEmptyObj(nextProps.messageData)) {
            this.showSummaryModal();
        }
        if (this.state.initialView && nextProps.mode === AccountModes.VIEW && nextProps.staticData.hideSummaryAccountMobile) {
            this.closeSummaryModal()
        }
    },
    showSummaryModal() {
        this.setState({showSummary: true});
    },
    closeSummaryModal() {
        if (this.state.showSummary)
            this.setState({showSummary: false, initialView: false});
    },
    changeSeason(eventKey){
        const season = this.props.seasons.find(season => {return season.key == eventKey});
        if (season)
            this.props.changeSeason(season);
    },
    onStoreClick() {
        this.props.checkIsDirty(function() {
            this.props.goToStore(this.props.staticData);
        }.bind(this));
    },
    getSeasonsHeader(){
        if(!this.props.currentSeason || !this.props.isFarmSeasonal)
            return undefined;
        if (this.props.seasons.length === 1)
            return (
                <div className="season-title">
                    {this.props.seasons[0].title}
                </div>
            );
        this.props.seasons.sort((a, b) => {
            return b.startDateStr.localeCompare(a.startDateStr);
        });
        return(<div className="season-row">
                <div className="season-title-label hidden-xs">{translate("Season")}</div>
                <DropdownButton title={this.props.currentSeason.title} className="season-dropdown" onSelect={this.changeSeason} id="season-dropdown-btn" bsStyle="default" disabled={this.props.isPreview}>
                    {this.props.seasons.map(season => {
                        return <MenuItem key={season.key} eventKey={season.key}>{season.title}</MenuItem>
                    })}
                </DropdownButton>
            </div>
        )
    },
    getTabsData() {
        let tabs = [];
        if (this.props.subscriptionSummary.status !== "NoSubscription")
            tabs.push({title:"Overview", key:"overview", content:<AccountOverviewPane history={this.props.history}
                                                                                      staticData={this.props.staticData}
                                                                                      clientViewPort={this.props.clientViewPort}/>});
        tabs.push({title: "Contact Info", key:"contact-info", content:<ContactDetailsForm flowType={URLs.ACCOUNT} setDirty={this.props.setDirty}/>});
        if ((!this.props.subscriptionSummary.hasMultiplePickupSites && this.props.pickupSite.type && this.props.pickupSite.type !== PickupSiteTypes.HOME) && !this.props.subscriptionSummary.status !== SubscriptionStatuses.NO_SUBSCRIPTION)
            tabs.push({title:translate("Pick-up Directions"), key:"directions",
                content:<AccountPickupDirectionsPane pickupSite={this.props.pickupSite}
                    clientViewPort={this.props.clientViewPort} errorFetching={this.props.errorFetching}/>});
        if ((!this.props.subscriptionSummary.hasMultiplePickupSites && this.props.staticData.allowUpdateVacation && this.props.subscriptionSummary.holdReason !== SubscriptionHoldReason.NEW) &&
            this.props.subscriptionSummary.status !== "NoSubscription" && !this.props.staticData.isPastSeason)
            tabs.push({title:translate("Delivery Hold"), key:"delivery-hold", content:<AccountDeliveryHoldPane/>});
        if (this.props.staticData.allowReportsToHost && this.props.subscriptionSummary.contactListReportURL)
            tabs.push({title:translate("Reports"), key:"reports", content:<AccountReportsPane subscriptionSummary={this.props.subscriptionSummary}
                                                                                   clientViewPort={this.props.clientViewPort}/>});
        return tabs;
    },
    onExit() {
        this.props.setShowPassword(false);
        this.props.setDirty(false);
    },
    onMobileTabsSelect(eventKey) {
        this.props.checkIsDirty(() => {this.setState({tabActiveKey: eventKey})});
    },
    getTabsMobile(){
        const tabs = this.getTabsData();
        return (<Tabs id="account-tabs" className="account-tabs" activeKey={this.state.tabActiveKey} defaultActiveKey={tabs[0].key} onSelect={this.onMobileTabsSelect}>
                {tabs.map(tab => {
                    return <Tab title=" " eventKey={tab.key} key={tab.key} tabClassName={tab.key + " _" + tabs.length}
                                unmountOnExit={true} onExiting={this.onExit.bind(this, tab.key)}>{tab.content}</Tab>
                })}
            </Tabs>);
    },
    getTabs(){
        const tabs = this.getTabsData();
        return (<SelectionTabs checkDirty={true} update={this.onExit} selectedTabTitle={this.props.defaultTab}>
                {tabs.map(tab => {
                    return <SelectionPane label={tab.title} key={tab.key}>{tab.content}</SelectionPane>
                })}
            </SelectionTabs>);
    },
    isShowManagePaymentButton() {
        const summary = this.props.subscriptionSummary;
        return ((summary.singlePaymentMethods||{}).length > 0 && (summary.singlePaymentPlans||{}).length > 0 ) ||
            (summary.autoPaymentMethods && summary.autoPaymentMethods.length > 0 && (summary.autoPaymentPlans||{}).length > 0 ) ||
            (summary.hasToken && summary.autoPaymentMethods && summary.autoPaymentMethods.length > 0);
    },
    getAccountHeaderMobile() {
        const seasonHeader = this.getSeasonsHeader();
        return (<div className="title-row">
            {seasonHeader ?
                seasonHeader
                :
                <div className="title">{translate("My Account")}</div>
            }
            {this.isShowManagePaymentButton() ?
                <AccountSummaryManagePayments/> : undefined}
            {this.props.subscriptionSummary.hasMultiplePickupSites ? undefined :
                <Button bsStyle="primary" className="summary-btn button"
                        onClick={this.showSummaryModal}>{translate("Summary")}</Button>
            }
        </div>);
    },
    getAccountHeader() {
        return (
            <div>
                <div className="title-row">
                    <div className="title">{translate("My Account")}</div>
                    {this.isShowManagePaymentButton()?
                        <AccountSummaryManagePayments/>:undefined}
                </div>
                <div>
                    {this.getSeasonsHeader()}
                </div>
            </div>
        )
    },
    getAccountScreenMobile() {
        return (<div>
            <div className="account-screen-mobile">
                {this.getAccountHeaderMobile()}
                {this.getTabsMobile()}
            </div>
            <Modal show={this.state.showSummary} onHide={this.closeSummaryModal} className="summary-modal">
                <Modal.Body>
                    <AccountSummary season={(this.props.currentSeason && this.props.isFarmSeasonal) ? this.props.currentSeason : undefined}/>
                </Modal.Body>
                <button className="close-button order-summary-popup visible-xs" onClick={this.closeSummaryModal}/>
            </Modal>
        </div>);
    },
    getAccountScreen() {
        if (this.props.mode == AccountModes.CHANGE_PICKUP_SITE) {
            return (<AccountChangePickupSite />);
        }
        if (this.props.mode == AccountModes.CHANGE_SUBSCRIPTION || this.props.mode == AccountModes.CHANGE_SUBSCRIPTION_THANKYOU) {
            return (<AccountChangeSubscription/>);
        }
        if (this.props.clientViewPort.isXs) {
            return this.getAccountScreenMobile();
        }
        return (
            <div>
                {this.getAccountHeader()}
                {this.getTabs()}
            </div>
        )
    },
    getScreen() {
        if (this.props.isFetching)
            return (<LoadingAnimation/>);
        if (!this.props.memberDetails.key)
            return (<LogInScreen />);
        if (this.props.location.pathname.endsWith('/thankyou'))
            return (<ThankYouPage pageContext={URLs.PAY} seasonUrl={this.props.staticData.seasonUrl}
                                  memberKey={this.props.memberDetails.key}
                                  mode={this.props.paymentType}
                                  extraMessage={(this.props.staticData.params || {}).message}
                                  farmUrl={this.props.staticData.farmUrl}/>);
        if (this.props.clientViewPort.isXs)
            return (
                this.getAccountScreen()
            );

        return (<Grid className="account-screen">
            <Row>
                <Col lg={8} md={10} sm={10}>
                    {this.getAccountScreen()}
                </Col>
                <Col className="summary-col" lg={4} md={2} sm={2}>
                    <div className="user-menu-wrapper">
                        <UserMenu disabled={this.props.isPreview}/>
                        {this.props.isPreview ?
                            <div className="preview-label">{translate("Preview")}</div>
                            : undefined
                        }
                        {this.props.staticData.storeButtonLabel &&
                            <Button bsStyle="primary" className="go-to-store-btn button" onClick={this.onStoreClick}>{translate(this.props.staticData.storeButtonLabel)}</Button>
                        }
                    </div>
                    {this.props.clientViewPort.isLg ?
                        <AccountSummary />
                        :
                        <DropdownButton id="summary-dropdown" defaultOpen={true} title={translate("Summary")} pullRight={true} noCaret={true}
                                        bsStyle="default">
                            <AccountSummary />
                        </DropdownButton>
                    }
                </Col>
            </Row>
        </Grid>);
    },
    render() {
        return (
            this.getScreen()
        )
    }
});

const mapStateToProps = (state) => {
    const account = state.account || {};
    const summary = state.summary || {};
    const mode = account.mode;
    const seasons = ((summary || {}).seasons || []);
    const currentSeason = seasons.find(season => {return season.key == state.staticData.seasonKey});
    const defaultTab =  (getUrlParams() || {}).tab;
    return {
        clientViewPort: (state.clientViewPort || {}),
        mode: mode,
        isPreview: (state.staticData || {}).isPreview,
        history: account.history || {},
        subscriptionSummary: summary,
        pickupSite: summary.pickupSite ||{},
        memberDetails: state.memberDetails || {},
        currentSeason: currentSeason,
        seasons: seasons,
        staticData: state.staticData,
        isFarmSeasonal: summary.isFarmSeasonal,
        isFetching: isFetching(state, FetchingTypes.LOAD_ACCOUNT_DATA),
        messageData: state.messageData,
        hasToken: summary.hasToken,
        defaultTab: defaultTab
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        initServerStaticData: () => {
          dispatch(initServerStaticData());
        },
        initMemberData: () => {
            dispatch(initMemberData());
        },
        setAndRemoveUrlParams: (onlyHidden) => {
            dispatch(setAndRemoveUrlParams(onlyHidden));
        },
        setMemberKey: (memberKey) => {
            dispatch(setMemberKey(memberKey));
        },
        getAccountData: () => {
            dispatch(getAccountData());
        },
        changeSeason: (season) => {
            dispatch(changeSeason(season));
        },
        setDirty: (isDirty) => {
            dispatch(setDirty(isDirty));
        },
        checkIsDirty: onLeaveCallBack => {
            dispatch(checkIsDirty(onLeaveCallBack));
        },
        setShowPassword: showPassword => {
            dispatch(setShowPassword(showPassword));
        },
        goToStore: (staticData) => {
            dispatch(setDirty(false));
            window.location.href = redirectPage(URLs.STORE, staticData);
        },
        errorFetching: (error) => {
            dispatch(errorFetching(error));
        },
        unsubscribeFlag: (flag) => {
            dispatch(unsubscribeFlag(flag));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps) (AccountHomeScreen);


// WEBPACK FOOTER //
// ./src/containers/account/AccountHomeScreen.js